<template>
    <div class="position-absolute w-100 h-100">

        <div class="w-100 pt-90 p-50 align-items-center uloha-wrap">

            <h3 class="pl-100 pr-100 mb-0">{{ otazka.zadanie }}</h3>

            <div class="mt-50 w-100">

                <template v-if="otazka.otazka_typ === 'radio'">
                    <template v-if="isVideo(otazka.subor)">
                        <div class="question-grid one-third-question">
                            <div class="position-relative">
                                <div class="rounded-10 overflow-hidden">
                                    <skoly-ulohy-kvizova-otazka-video-thumbnail :subor="otazka.subor" />
                                </div>
                                <span class="play-btn" @click="showVideo(otazka.subor)"><span class="icon icon--play"></span></span>
                            </div>
                            <skoly-ulohy-kvizova-otazka-moznosti :otazka="otazka" :show-result="showResult" :odpoved="odpoved" @playVideo="showVideo"/>
                        </div>
                    </template>

                    <template v-else-if="isAudio(otazka.subor)">
                        <div class="question-grid one-third-question">
                            <div class="bg-light-brown p-30 --rounded">
                                <p class="text-white text-bold text-dark text-left mb-15">Prehrajte si zvuk</p>
                                <skoly-ulohy-kvizova-otazka-audio :subor="otazka.subor" />
                            </div>
                            <skoly-ulohy-kvizova-otazka-moznosti :otazka="otazka" :show-result="showResult" :odpoved="odpoved" @playVideo="showVideo" />
                        </div>
                    </template>

                    <template v-else-if="isImage(otazka.subor)">
                        <div class="question-grid mb-35">
                            <img v-if="otazka.subor" :src="skolyStorage + otazka.subor" alt="" class="img-fluid rounded-10">
                            <skoly-ulohy-kvizova-otazka-moznosti :otazka="otazka" :show-result="showResult" :odpoved="odpoved" @playVideo="showVideo" />
                        </div>
                    </template>

                    <template v-else>
                        <skoly-ulohy-kvizova-otazka-moznosti class="question-grid cols-answers-3" :otazka="otazka" :show-result="showResult" :odpoved="odpoved" @playVideo="showVideo" />
                    </template>
                </template>

                <template v-else>

                    <div class="question-grid answers-below">

                        <template v-if="isVideo(otazka.subor)">
                            <div class="position-relative w-40">
                                <div class="rounded-10 overflow-hidden">
                                    <skoly-ulohy-kvizova-otazka-video-thumbnail :subor="otazka.subor" />
                                </div>
                                <span class="play-btn" @click="showVideo(otazka.subor)"><span class="icon icon--play"></span></span>
                            </div>
                        </template>

                        <template v-else-if="isAudio(otazka.subor)">
                            <div class="bg-light-brown p-30 --rounded d-flex align-items-center w-720">
                                <p class="text-white text-bold text-dark text-left mb-0 mr-30 flex-0">Prehrajte si zvuk</p>
                                <skoly-ulohy-kvizova-otazka-audio :subor="otazka.subor" />
                            </div>
                        </template>

                        <template v-else>
                            <div class="position-relative w-360 h-240">
                                <img v-if="otazka.subor" :src="skolyStorage + otazka.subor" alt="" class="img-fluid rounded-10">
                            </div>
                        </template>

                        <b-textarea
                                rows="3"
                                placeholder="Napíšte svoju odpoveď ..."
                                v-model="odpoved.input"
                                :class="{
                                    'valid': showResult && otazka.textove_varianty.includes(odpoved.input),
                                    'invalid': showResult && !otazka.textove_varianty.includes(odpoved.input)
                                }"
                                :disabled="showResult"
                        />
                        <p class="mb-0" v-if="showResult && !otazka.textove_varianty.includes(odpoved.input)"><strong class="text-success">Akceptované odpovede:</strong> {{ otazka.textove_varianty.join(', ') }}</p>

                    </div>

                </template>

            </div>

            <skoly-ulohy-kvizova-otazka-button :show-result="showResult" :odpoved="odpoved" @next="next" @checkResponse="checkResponse" />

        </div>

        <skoly-ulohy-kvizova-otazka-video :subor="videoToPlay" />

<!--        <b-modal id="obrazok-modal" hide-backdrop hide-header hide-footer>-->
<!--            <template #default="{ hide }">-->
<!--                <img src="assets/img/full-obr.jpg" alt="">-->
<!--                <a class="btn &#45;&#45;secondary &#45;&#45;circle close-btn" @click="hide()"><span class="icon &#45;&#45;close"></span></a>-->
<!--            </template>-->
<!--        </b-modal>-->

    </div>
</template>

<script>
import EventService from "@/services/EventService";
import SkolyUlohyKvizovaOtazkaButton from "@/components/skoly/SkolyUlohyKvizovaOtazkaButton.vue";
import SkolyUlohyKvizovaOtazkaMoznosti from "@/components/skoly/SkolyUlohyKvizovaOtazkaMoznosti.vue";
import SkolyUlohyKvizovaOtazkaAudio from "@/components/skoly/SkolyUlohyKvizovaOtazkaAudio.vue";
import SkolyUlohyKvizovaOtazkaVideo from "@/components/skoly/SkolyUlohyKvizovaOtazkaVideo.vue";
import SkolyUlohyKvizovaOtazkaVideoThumbnail from "@/components/skoly/SkolyUlohyKvizovaOtazkaVideoThumbnail.vue";
import multimedia from "@/mixins/multimedia";

export default {
    components: {
        SkolyUlohyKvizovaOtazkaVideoThumbnail,
        SkolyUlohyKvizovaOtazkaVideo,
        SkolyUlohyKvizovaOtazkaAudio, SkolyUlohyKvizovaOtazkaMoznosti, SkolyUlohyKvizovaOtazkaButton},
    props: [
        'otazka'
    ],
    mixins: [ multimedia ],
    data() {
        return {
            odpoved: {
                input: '',
                correct: false
            },
            showResult: false,
            videoToPlay: '',
        }
    },
    computed: {
        skolyStorage() {
            return EventService.getUlohyStorageUrl()
        },
    },
    mounted() {
    },
    methods: {
        checkResponse() {
            this.showResult = true
        },
        next() {
            this.$emit('next', this.odpoved)
        },
        showVideo(subor) {
            this.$bvModal.show('video-modal')
            this.videoToPlay = subor;
        }
    }
}
</script>
